$(document).ready(() => {

	$( '#skip-to-content' ).on( 'click', function( event ) {

		event.preventDefault()

		$('html,body').animate({ scrollTop: $( '#page-content' ).offset().top }, 0);

		$( 'h1' ).focus()

	} )

	$(".navbar-nav a").filter('[role="button"]').on('keydown', function(e) {

		if ( e.which == 32 ) {

			e.preventDefault()

			$( e.target )[0].click()

		}

    });

})